import React, { useContext, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import NavbarTop from '../components/navbar/top/NavbarTop';
import NavbarVertical from '../components/navbar/vertical/NavbarVertical';
import AppContext from '../context/Context';
import i18n from 'i18next';
import Footer from '../components/footer/Footer';
import ProductProvider from '../components/app/e-commerce/ProductProvider';
import infiniteLoop from '../assets/img/animated-icons/infinite-loop.json';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import {
  getUserGridsDefinition,
  getUserProfile,
  getRbacDetails,
  getLinerConfig,
} from '../app/common/actions/userDetails';
import { useSelector } from 'react-redux';
import {
  updateLinerCountryList,
  updateLinerDataCountry,
  updateRbacDetails,
  updatelinerGrpCountry,
} from '../app/common/slices/userDetails';
import {
  AESDecryptAny,
  AESEncryptAny,
} from '../encrypt-util';
import Lottie from 'lottie-react';
import { useNavigate } from 'react-router-dom';
import useDataCountry from '../hooks/useDataCountry';
import { clearGrids } from '../app/common/components/DataTable/slices/DataTable';
import NotificationModal from './NotificationModal';
import { getCustomersDetailsByPartnerId } from '../app/features/profile/action/ProfileAccount';
import { toast } from 'react-toastify';
const MainLayout = () => {
  const APP_PATH_PREFIX = process.env.REACT_APP_APP_PATH_PREFIX || '';
  const { hash, pathname } = useLocation();
  const isKanban = pathname.includes('kanban');
  const profileDetails = useSelector((state) => state.userProfile.profile);
  const showMainLayout = useSelector(
    (state) => state.themeSettings.showMainLayout
  );
  const dataCountry = useDataCountry();
  const loading = useSelector((state) => state.loading.globalLoading);
  const partnerCountry = profileDetails.partnerCountry;

  const linerGrpCountry = useSelector(
    (state) => state.userProfile.linerGrpCountry
  );
  const dispatch = useDispatch();
  const linerId = useSelector((state)=>state.navbarTop.linerId)

  // const isChat = pathname.includes('chat');
  useEffect(() => {
    dispatch(getUserProfile());
    dispatch(getRbacDetails());
   /*  dispatch(getCustomersDetailsByPartnerId({}))
          .unwrap()
          .then((response) => {
            //console.log("response",response.phnNo);
            const today = new Date().toISOString().split('T')[0]; // e.g., "2024-06-13"
            const lastShown = localStorage.getItem('updatePhonePromptDate');
            if (!/^\d+$/.test(response.phnNo)) {
              if (lastShown !== today) {
                toast.info(
                  <div onClick={() => navigate("/user/profile")}>
                    Kindly update the ‘Phone Number’ in the User Profile section
                  </div>
                );
                localStorage.setItem('updatePhonePromptDate', today);
              }
            }
       
          }) */
  }, []);
  const rbac = useSelector(
    (state) => state.userProfile.data?.response?.data?.list
  );
  const linerCountryList = useSelector(
    (state) => state.userProfile.countryList
  );
  const linerDataCountry = useSelector(
    (state) => state.userProfile.linerDataCountry
  );
  useEffect(() => {
    const rbacData2 = [];
    const jsonRbac = rbac?.map((v) => JSON.parse(v?.rbacColumnConfig));
    const countryList = rbac?.map((v) => v?.countryList)
    // const countryList = rbac
    // ?.map((v) => ({
    //   countryName: v?.countryName,
    //   countryCode: v?.countryAccess
    // }))
    // ?.filter((country, index, array) => 
    //   country.countryName && 
    //   country.countryName.trim() !== '' &&
    //   country.countryCode && 
    //   array.findIndex(c => 
    //     c.countryName === country.countryName && 
    //     c.countryCode === country.countryCode
    //   ) === index
    // );
    if (jsonRbac) {
      for (const rbac of jsonRbac) {
        Object.entries(rbac).forEach(([key, val]) => {
          rbacData2[key] = val == 'Y' || rbacData2[key] == 'Y' ? 'Y' : '';
        });
      }
    }
    if (profileDetails?.partnerType == null) {
      dispatch(getUserProfile());
    }
    if (/*profileDetails?.partnerType == 'liner' ||*/ countryList) {
      if (countryList) {
        for (let k of Object(countryList)) {
          dispatch(updateLinerCountryList(k));
        }
          //dispatch(updateLinerCountryList(countryList));
      }
      if(profileDetails?.partnerType == 'liner'){
      for (let k of Object(rbac?.map((v) => v?.grpCountry))) {
        dispatch(updatelinerGrpCountry(k));
      }
      }
    }

    dispatch(updateRbacDetails(rbacData2));
  }, [rbac]);
  const userSelectedCountry =
    AESDecryptAny(window.localStorage.getItem('@user-selected-datacountry')) || [];
  const selectedCountry =
    userSelectedCountry?.[0]?.loginId === profileDetails?.email
      ? userSelectedCountry?.[0]?.country
      : profileDetails.partnerType === 'customer'
      ? profileDetails.partnerCountry
      : null;
  const userName = profileDetails.username;
  // debugger
  const selectedLinerDataCountry = selectedCountry
    ? selectedCountry
    : linerDataCountry
    ? linerDataCountry
    : linerCountryList
    ? linerCountryList[0]?.countryCode
    : profileDetails.partnerType === 'customer'
    ? profileDetails.partnerCountry
    : null;
  const language = useSelector((state)=> state.navbarTop.language);  
  useEffect(() => {
    const storedUserData =
      AESDecryptAny(window.localStorage.getItem('@stored-user-data')) || [];
    const storedDataCountry =
      AESDecryptAny(window.localStorage.getItem('@user-selected-dataCountry')) ||
      [];
    if (selectedLinerDataCountry || selectedLinerDataCountry != null) {
      dispatch(updateLinerDataCountry(selectedLinerDataCountry));
      const updateAndFetchCountry = (selectedLinerDataCountry) => {
        const userSelectedCountry = [
          {
            loginId: profileDetails.email,
            country: selectedLinerDataCountry,
          },
        ];
        window.localStorage.setItem(
          '@user-selected-datacountry',
          AESEncryptAny(JSON.stringify(userSelectedCountry))
        );

        // dispatch(getUserGridsDefinition(selectedLinerDataCountry))
        //   .then((data) => {
        //     const updatedUserData = [
        //       ...storedUserData,
        //       { username: userName, country: selectedLinerDataCountry },
        //     ];
        //     window.localStorage.setItem(
        //       '@stored-user-data',
        //       AESEncryptAny(JSON.stringify(updatedUserData))
        //     );
        //   })
        //   .catch((error) => {
        //     // Handle API call error here
        //     console.error('Error fetching user grids definition:', error);
        //   });

        i18n.changeLanguage(`${selectedLinerDataCountry}_${language}`);
      };
      const currentUserData = {
        username: userName,
        country: selectedLinerDataCountry,
      };

      const findUserIndex = storedUserData.findIndex(
        (user) => user.username === userName
      );

      const isUserLiner = profileDetails.partnerType === 'liner';
      const hasCurrentUserStoredData = !!(
        findUserIndex !== -1 && storedUserData[findUserIndex]?.country
      );

      if (!hasCurrentUserStoredData) {
        let selectedCountry = null;
        if (isUserLiner && selectedLinerDataCountry) {
          selectedCountry = selectedLinerDataCountry;
        } else if (partnerCountry) {
          selectedCountry = partnerCountry;
        }

        if (selectedCountry) {
          updateAndFetchCountry(selectedCountry);
        }
      } else {
        //const storedCountry = storedUserData[findUserIndex].country;
        const storedCountry =
          storedDataCountry.loginId === profileDetails.email
            ? storedDataCountry.country
            : '';
        if (selectedCountry !== storedCountry) {
          updateAndFetchCountry(selectedCountry);
        } else {
          //dispatch(getUserGridsDefinition(storedCountry));
          i18n.changeLanguage(`${storedCountry}_${language}`);
        }
      }
    }
  }, [
    userName,
    linerId,
    linerDataCountry,
    partnerCountry,
    profileDetails.partnerType,
    selectedLinerDataCountry,
    language
  ]);

  const {
    config: { isFluid, navbarPosition },
  } = useContext(AppContext);

  useEffect(() => {
    setTimeout(() => {
      if (hash) {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }
    }, 0);
  }, []);

  useEffect(() => {
    dispatch(clearGrids());
  }, [dataCountry]);

  useEffect(() => {
    const APP_PATH_PREFIX = process.env.REACT_APP_APP_PATH_PREFIX || '';
    if (!pathname.includes(`${APP_PATH_PREFIX}/user/profile`)) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  useEffect(()=>{
    if(!dataCountry || !linerId)return
    dispatch(getLinerConfig({country:dataCountry, linerId:linerId})) 
  },[dataCountry, linerId])

  const navigate = useNavigate();
  return (
    <div
      className={isFluid ? 'container-fluid' : 'container'}
      style={
        loading
          ? { pointerEvents: 'none', opacity: '50%', overflow: 'hidden' }
          : {}
      }
    >
      {loading && (
        <div
          className='d-flex overflow-hidden'
          style={{
            position: 'absolute',
            zIndex: 99999,
            justifyContent: 'center',
            width: '100vw',
            height: '100vh',
          }}
        >
          <Lottie
            animationData={infiniteLoop}
            loop={true}
            style={{
              height: '20vh',
              width: '20vh',
              alignSelf: 'center',
              justifySelf: 'center',
            }}
          />
        </div>
      )}

       {profileDetails.pwdExpired?.toUpperCase() === 'Y' &&
         navigate(`${APP_PATH_PREFIX}/reset-password`)}

      {showMainLayout &&
        (navbarPosition === 'vertical' || navbarPosition === 'combo') && (
          <NavbarVertical />
        )}
      <ProductProvider>
          <div className={classNames('content', { 'pb-0': isKanban })}>
            {showMainLayout && <NavbarTop />}
            {/*------ Main Routes ------*/}
            <Outlet />
            {/* {!isKanban && <Footer />} */}
          </div>
        </ProductProvider>
      <NotificationModal/>
    </div>
  );
};

export default MainLayout;
